import AbstractScene from './AbstractScene.js';
import ControllButton from '../prefabs/ControllBoard/ControllButton.js';
import ParallaxLayer from '../prefabs/ParallaxLayer.js';
import Player from '../prefabs/Player.js';
import ObstacleSpawner from '../prefabs/obstacles/ObstacleSpawner.js';
import FishSpawner from '../prefabs/poissons/FishSpawner.js';
import Chrono from '../prefabs/Chrono.js';
import { Colors } from '../consts/Colors.js';
import LifeCount from '../prefabs/LifeCount.js';

export default class Game extends AbstractScene {
    constructor() {
        super({
            key: 'Game',
        });
    }
    init(data) {
        this._init(data);
        this.parallaxSpeed = 1200;
        this.obstacleSpawnDelay = 1300;
        this.fishSpawnDelay = 1200;
        this.switchLaneDuration = 80;
        this.numLanes = 5;
        this.laneSpacing = 90;
        this.turtleHeight = 81 * this.game.data.scaleY;

        const centerY = this.scale.height / 2;

        this.laneOne = centerY - 2 * this.laneSpacing;
        this.laneTwo = centerY - 1 * this.laneSpacing;
        this.laneThree = centerY;
        this.laneFour = centerY + 1 * this.laneSpacing;
        this.laneFive = centerY + 2 * this.laneSpacing;

        this.turtleLane = this.laneThree;

        this.resteSenneOn = false;
    }

    preload() {
        this._preload();
        this.paraNumber = 10;
        this.spawnerActive = false;

        this.currentLane = 3;
        this.level = this.game.data.level;
        this.errorsCount = this.game.data.errorsCount;
        this.chronoDuration = this.game.data.chronoDuration;
        this.chronoText = this.game.data.chronoText;

        this.upKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.UP);
        this.downKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.DOWN);

        if (this.anims.get('turtleAnim') == undefined) {
            this.createAnimations();
            // this.initParallaxObstacles();
        }
        this.anims.resumeAll();
    }
    update(time, delta) {
        this.parallaxLayerFond.moveParallax(delta);
        this.parallaxLayerPlan1.moveParallax(delta);
        this.parallaxLayerPlan2.moveParallax(delta);
        this.parallaxLayerPlan4.moveParallax(delta);
        this.parallaxLayerBulles.moveParallax(delta);

        if (this.spawnerActive) {
            this.fishSpawner.moveObstacles(delta); // déplacement des poissons
            this.spawner.moveObstacles(delta); // déplacement des obstacles
            if (!this.turtle.isHited) {
                this.checkCollision();
            }
        }

        if (this.chrono) {
        }
    }

    create() {
        this.initParallaxFirst();
        let orignX = 150 * this.game.data.scaleX;
        let turtleDuration = 200;
        if (this.game.data.tutoOn === false) {
            orignX = 1000 * this.game.data.scaleX;
            turtleDuration = 1500;
        }
        this.turtle = new Player(this, orignX, this.turtleLane, {
            level: this.errorsCount,
            showHitbox: false,
        });
        this.initParallaxSecond();
        this.addControlBoard();
        this.chrono = new Chrono(
            this,
            this.width - 100,
            46 * this.game.data.scaleY,
            this.chronoText,
            this.chronoDuration
        );
        this.lifeCount = new LifeCount(this, this.errorsCount);
        if (this.game.data.firstScreen === false) {
            this.chrono.timerText.setText(this.game.data.chronoText);
        }
        this.add.tween({
            targets: this.turtle,
            duration: turtleDuration,
            x: 150 * this.game.data.scaleX,
            onComplete: () => {
                this.chrono.startTimer();
                this.add.tween({
                    targets: this.controlBoard,
                    duration: 500,
                    alpha: 1,
                    onComplete: () => {
                        this.upBtn.setActive();
                        this.downBtn.setActive();
                        this.spawner = new ObstacleSpawner(this, 0, 0, this.obstacleSpawnDelay);
                        this.fishSpawner = new FishSpawner(this, 0, 0, this.fishSpawnDelay);
                        this.spawnerActive = true;
                        // this.chrono.startTimer()
                    },
                });
            },
        });

        this.upKey.on('down', (event) => {
            this.turtleMoveUp();
        });
        this.downKey.on('down', (event) => {
            this.turtleMoveDown();
        });
    }

    addControlBoard() {
        this.controlBoard = this.add.container(0, 0).setDepth(4).setAlpha(0);
        this.upBtn = new ControllButton(this, 100, 'up');
        this.downBtn = new ControllButton(this, this.width - 100, 'down');
        this.controlBoard.add(this.upBtn);
        this.controlBoard.add(this.downBtn);
    }

    createAnimations() {
        // this.anims.create({
        //     key: 'filetAnim',
        //     frames: this.anims.generateFrameNumbers('filetMaillantSprite', { start: 0, end: 3 }),
        //     frameRate: 2,
        //     repeat: -1,
        // });
        this.anims.create({
            key: 'turtleAnim',
            frames: this.anims.generateFrameNumbers('tortue', { start: 0, end: 10 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'turtleNetAnim',
            frames: this.anims.generateFrameNumbers('tortueNet', { start: 0, end: 10 }),
            frameRate: 11,
            repeat: -1,
        });

        this.anims.create({
            key: 'poissonAnim1',
            frames: this.anims.generateFrameNumbers('poisson1', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        // this.anims.create({
        //     key: 'fishAnim1',
        //     frames: this.anims.generateFrameNumbers('fishSprite', { start: 0, end: 1 }),
        //     frameRate: 2,
        //     repeat: -1
        // });
        this.anims.create({
            key: 'poissonAnim2',
            frames: this.anims.generateFrameNumbers('poisson2', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim3',
            frames: this.anims.generateFrameNumbers('poisson3', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        // this.anims.create({
        //     key: 'poissonAnim4',
        //     frames: this.anims.generateFrameNumbers('poisson4', { start: 0, end: 0 }),
        //     frameRate: 11,
        //     repeat: -1
        // });
        this.anims.create({
            key: 'poissonAnim5',
            frames: this.anims.generateFrameNumbers('poisson5', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim6',
            frames: this.anims.generateFrameNumbers('poisson6', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim7',
            frames: this.anims.generateFrameNumbers('poisson7', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim8',
            frames: this.anims.generateFrameNumbers('poisson8', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim9',
            frames: this.anims.generateFrameNumbers('poisson9', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim10',
            frames: this.anims.generateFrameNumbers('poisson10', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
    }

    initParallaxObstacles() {
        const filetParts = [
            'filetMaillantSprite_part1',
            'filetMaillantSprite_part2',
            'filetMaillantSprite_part3',
            'filetMaillantSprite_part4',
        ];

        this.parallaxLayerFilet = new ParallaxLayer(this, 0, 0, 500);
        this.parallaxLayerFilet = new ParallaxLayer(this, 0, 0, 500);

        filetParts.forEach((part, i) => {
            const texture = this.parallaxLayerFilet.addTexture(part);

            this.tweens.add({
                targets: texture,
                y: texture.y + 10,
                duration: 1500 + i * 200,
                ease: 'Sine.easeInOut',
                repeat: -1,
                yoyo: true,
            });
        });
    }

    initParallaxFirst() {
        const fondParts = [
            'fond_part1',
            'fond_part2',
            'fond_part3',
            'fond_part4',
            'fond_part5',
            'fond_part6',
            'fond_part7',
            'fond_part8',
            'fond_part9',
        ];
        const plan4Parts = [
            'plan4_part1',
            'plan4_part2',
            'plan4_part3',
            'plan4_part4',
            'plan4_part5',
            'plan4_part6',
            'plan4_part7',
            'plan4_part8',
            'plan4_part9',
        ];
        const plan2Parts = [
            'plan2_part1',
            'plan2_part2',
            'plan2_part3',
            'plan2_part4',
            'plan2_part5',
            'plan2_part6',
            'plan2_part7',
            'plan2_part8',
            'plan2_part9',
        ];

        this.parallaxLayerFond = new ParallaxLayer(this, 0, 0, 200);
        fondParts.forEach((part) => this.parallaxLayerFond.addTexture(part));

        this.parallaxLayerPlan4 = new ParallaxLayer(this, 0, 0, 300);
        plan4Parts.forEach((part) => this.parallaxLayerPlan4.addTexture(part));

        this.parallaxLayerPlan2 = new ParallaxLayer(this, 0, 0, 450);
        plan2Parts.forEach((part) => this.parallaxLayerPlan2.addTexture(part));
    }

    initParallaxSecond() {
        const plan1Parts = [
            'plan1_part1',
            'plan1_part2',
            'plan1_part3',
            'plan1_part4',
            'plan1_part5',
            'plan1_part6',
            'plan1_part7',
            'plan1_part8',
            'plan1_part9',
        ];
        const bullesParts = [
            'bulles_part1',
            'bulles_part2',
            'bulles_part3',
            'bulles_part4',
            'bulles_part5',
            'bulles_part6',
            'bulles_part7',
            'bulles_part8',
            'bulles_part9',
        ];

        this.parallaxLayerPlan1 = new ParallaxLayer(this, 0, 0, 500);
        this.parallaxLayerPlan1.setDepth(4);
        plan1Parts.forEach((part) => this.parallaxLayerPlan1.addTexture(part));

        this.parallaxLayerBulles = new ParallaxLayer(this, 0, -400 * this.game.data.scaleY, 475);
        bullesParts.forEach((part) => this.parallaxLayerBulles.addTexture(part));

        this.tweens.add({
            targets: this.parallaxLayerBulles,
            y: this.parallaxLayerBulles.y + 10,
            duration: 1500,
            repeat: -1,
            yoyo: true,
        });
    }
    turtleMoveUp() {
        if (this.currentLane !== 1) {
            this.add.tween({
                targets: this.turtle,
                duration: this.switchLaneDuration,
                y: this.turtle.y - this.laneSpacing,
                onComplete: () => {
                    this.currentLane = this.currentLane - 1;
                    // console.log("this.currentline", this.currentLane)
                    // console.log("this.turtle.y", this.turtle.y)
                    if (this.currentLane === 1 && this.firstTuto) {
                        this.firstTuto = false;
                        this.secondTuto = true;
                        this.changeTutoPopup(TextContents.textTuto2);
                        this.tutoPopup.setAlpha(1);
                        this.animBtnControl(this.downBtn);
                    }
                },
            });
        }
    }
    turtleMoveDown() {
        if (this.currentLane !== 5) {
            this.add.tween({
                targets: this.turtle,
                duration: this.switchLaneDuration,
                y: this.turtle.y + this.laneSpacing,
                onComplete: () => {
                    this.currentLane = this.currentLane + 1;
                    // console.log('this.currentline', this.currentLane);
                    // console.log('this.turtle.y', this.turtle.y);
                    // console.log('this.laneFive', this.laneFive);
                    // console.log('this.secondTuto', this.secondTuto);
                    if (this.turtle.y === this.laneFive && this.secondTuto === true) {
                        // console.log('laneFive')
                        this.secondTuto = false;
                        this.thirdTuto = true;
                        this.changeTutoPopup(TextContents.textTuto3);
                        this.tutoPopup.setAlpha(1);
                    }
                },
            });
        }
    }

    checkCollision() {
        var rect1 = this.turtle.hitbox.getBounds();

        this.spawner.obstacles.forEach((obstacle, index) => {
            var rect2 = obstacle.hitbox.getBounds();
            if (Phaser.Geom.Intersects.RectangleToRectangle(rect1, rect2)) {
                if (!this.turtle.isHited) {
                    this.game.data.chronoDuration = this.chrono.timeLeft;
                    this.game.data.chronoText = this.chrono.timerText.text;
                    // console.log('chrono texte', this.game.data.chronoText)
                    this.chrono.stopTimer();
                    this.scene.start('Quiz');
                }
            }
        });
    }
}
